import { render, staticRenderFns } from "./JobBadge.vue?vue&type=template&id=a9f2f4fa&"
import script from "./JobBadge.vue?vue&type=script&lang=js&"
export * from "./JobBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports